module.exports = __webpack_public_path__ + "static/media/shape0_1.1f6eec82.obj";